export const TELEGRAM_URL = 'https://t.me/Mixtura_support';
export const EMAIL_URL = 'mailto:mixturasupport@protonmail.com';
export const CLEARNET_URL = 'https://mixtura.money';
export const TOR_NETWORK_URL =
    'http://3lqpiyzlqudwxiizx6uecc6z5zr6vvxidyi6inuducc7lilsdem2mlqd.onion';
